"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ItemContainer_module_scss_1 = __importDefault(require("./ItemContainer.module.scss"));
const react_i18next_1 = require("react-i18next");
const feed_factory_hover_desc_1 = require("@feed-factory/feed-factory.hover-desc");
// TODO: Refactor Media Item components with proto component
const ItemContainer = react_1.default.forwardRef((props, ref) => {
    var _a, _b, _c;
    const { t } = (0, react_i18next_1.useTranslation)();
    const [imageDimensions, setImageDimensions] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const image = new Image();
        const hlink = props.item.hlink;
        if (props.item.mediatype !== "photo")
            return;
        image.onload = () => {
            setImageDimensions({
                width: image.naturalWidth,
                height: image.naturalHeight,
            });
            // there must be backend support that gives the filesize
            // using the performance api returns a size of 0 if the
            // file is loaded from cache. It seems undesirable to
            // force the image to not be loaded from cache.
            // Thus, backend support is likely the best option
            // var iTime = performance.getEntriesByName(hlink)[0];
            // console.log(iTime);
        };
        image.src = hlink;
    }, [props.item.hlink, props.item.mediatype]);
    // TODO: Add placeholder image if image at url is not available
    return (react_1.default.createElement("div", Object.assign({ className: ItemContainer_module_scss_1.default.ItemContainer, ref: ref, style: props.style }, props.draggableProps, props.dragHandleProps),
        props.children,
        react_1.default.createElement("div", { className: ItemContainer_module_scss_1.default.MetaData },
            props.item.mediatype === "photo" && (react_1.default.createElement(react_1.default.Fragment, null, imageDimensions && (react_1.default.createElement("div", null,
                t("form.filedimensions"),
                ": ",
                imageDimensions.width,
                "x",
                imageDimensions.height)))),
            react_1.default.createElement("div", null,
                t("form.filesize"),
                ": ",
                props.item.filesize || t("form.unknownFileSize")),
            react_1.default.createElement("div", null, props.item.targetLanguage),
            react_1.default.createElement("div", null, props.item.trcid)),
        !props.isDragging && (react_1.default.createElement("div", { className: ItemContainer_module_scss_1.default.Interface },
            react_1.default.createElement("label", null,
                t("form.title"),
                react_1.default.createElement(feed_factory_hover_desc_1.HoverDesc, { description: "form.title.desc" }),
                " "),
            react_1.default.createElement("input", { value: (_b = (_a = props.item.title) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "", onChange: (event) => {
                    props.handleItemChange(props.item.hlink, "title.label", event.currentTarget.value);
                } }),
            react_1.default.createElement("label", null,
                t("form.copyright"),
                react_1.default.createElement(feed_factory_hover_desc_1.HoverDesc, { description: "form.copyright.desc" })),
            react_1.default.createElement("input", { value: (_c = props.item.copyright) !== null && _c !== void 0 ? _c : "", onChange: (event) => {
                    props.handleItemChange(props.item.hlink, "copyright", event.currentTarget.value);
                } }),
            react_1.default.createElement("button", { type: "button", className: ItemContainer_module_scss_1.default.DeleteButton, onClick: () => {
                    props.onRemove(props.item.hlink);
                } }, t("form.delete"))))));
});
exports.default = ItemContainer;
//# sourceMappingURL=ItemContainer.js.map